import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import NoOrders from "../home/img/features/f2.png";
import Loader from "../home/Loader";
import PageTitle from "../store/PageTitle";
import "./orders.css";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const api = {
  fetchMyOrders: async (userId) => {
    const response = await fetch(`${serverUrl}/my_orders/${userId}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error("Failed to fetch Orders");
    }
    return await response.json();
  },
};

const OrdersTable = () => {
  const [sortConfig, setSortConfig] = useState({
    key: "orderDate",
    direction: "descending",
  });
  const userId = useSelector((state) => state.auth.user?.id);
  const [loading, setLoading] = useState(false);

  // fetch orders

  // Fetch orders
  const [orders, setOrders] = useState([]);

  const HandleFetchOrders = async (userId) => {
    if (!userId) return;
    setLoading(true);
    try {
      const data = await api.fetchMyOrders(userId);
      setOrders(data || []);
    } catch (err) {
      console.error("Error fetching orders:", err);
      toast.error("Failed to fetch Your orders. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    HandleFetchOrders(userId);
  }, [userId]);

  // Handle sorting
  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  // Sort orders based on current configuration
  const sortedOrders = [...orders].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  // Format price with currency symbol
  const formatPrice = (price) => {
    return `K${price.toFixed(2)}`;
  };

  // Format date
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // handle order cart_items click

  const navigate = useNavigate();

  const handleOrderClick = async (order) => {
    setLoading(true);

    try {
      const orderId = order.id;

      // Fetch Order Items
      const orderItemsRes = await fetch(`${serverUrl}/orders_cart/${orderId}`);
      const orderItems = await orderItemsRes.json();
      console.log("cart items", orderItems);

      // Navigate to Order Details page with fetched data
      navigate(`/MyOrder/${orderId}`, {
        state: { order, orderItems },
      });
    } catch (error) {
      console.error("Error fetching order details:", error);
      toast.error("Failed to load order details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="orders-container">
      <PageTitle title="My Orders" />
      {loading && <Loader />}
      <h2>My Orders</h2>
      {orders.length === 0 ? (
        <div className="no-orders">
          <div className="no-img">
            <img src={NoOrders} alt="no orders" />
          </div>
          <span> You don't have any orders yet.</span>
        </div>
      ) : (
        <div className="orders-table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th onClick={() => requestSort("id")} className="sortable">
                  Order ID
                  {sortConfig.key === "id" && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "ascending" ? " ▲" : " ▼"}
                    </span>
                  )}
                </th>
                <th
                  onClick={() => requestSort("order_date")}
                  className="sortable"
                >
                  Date
                  {sortConfig.key === "order_date" && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "ascending" ? " ▲" : " ▼"}
                    </span>
                  )}
                </th>

                <th onClick={() => requestSort("total")} className="sortable">
                  Total
                  {sortConfig.key === "total" && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "ascending" ? " ▲" : " ▼"}
                    </span>
                  )}
                </th>
                <th
                  onClick={() => requestSort("payment_status")}
                  className="sortable"
                >
                  Payment
                  {sortConfig.key === "payment_status" && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "ascending" ? " ▲" : " ▼"}
                    </span>
                  )}
                </th>
                <th
                  onClick={() => requestSort("order_status")}
                  className="sortable"
                >
                  Status
                  {sortConfig.key === "order_status" && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "ascending" ? " ▲" : " ▼"}
                    </span>
                  )}
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedOrders.map((order) => (
                <tr
                  key={order.id}
                  className={`status-${order.order_status.toLowerCase()}`}
                >
                  <td>#{order.id}</td>
                  <td>{formatDate(order.order_date)}</td>

                  <td>{formatPrice(order.total)}</td>
                  <td>
                    <span
                      className={`status-badge ${order.payment_status.toLowerCase()}`}
                    >
                      {order.payment_status}
                    </span>
                  </td>
                  <td>
                    <span
                      className={`status-badge ${order.order_status.toLowerCase()}`}
                    >
                      {order.order_status}
                    </span>
                  </td>

                  <td>
                    <button
                      onClick={() => handleOrderClick(order)}
                      key={order.id}
                      className="view-details-btn"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <ToastContainer position="top-center" />
          </table>
        </div>
      )}
    </div>
  );
};

export default OrdersTable;
